export default __webpack_public_path__ + "static/media/wordpress.5e4b53fd.jpg";